import { Injectable } from '@angular/core';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { AbstractAnnotationStore } from '../../annotation-shared/state/root/abstract-annotation-store';
import { PointCloudState } from './point-cloud-state';
import { TransientMeshLayerState } from './transient-mesh-layer-state';

@Injectable()
export class PointCloudStore extends AbstractAnnotationStore<PointCloudState> {
  constructor() {
    super(new PointCloudState());
  }

  getTransientFromActiveMeshLayer$<K extends keyof TransientMeshLayerState>(
    key: K,
  ) {
    return this.getActiveLayer$().pipe(
      map((shapeLayer) => shapeLayer.transient[key]),
      distinctUntilChanged(),
    );
  }
}
